export default __webpack_public_path__ + "static/media/linen-texture.3909a128.png";